import { selector } from './selector';
import Swal from 'sweetalert2';

const formSubmit = (e) => {
    e.preventDefault();

    const $form = $(e.target).closest(selector.form)
    const actionUrl = $form.attr('action')

    let formData = $form.serialize();

    $.ajax({
        url: actionUrl,
        method: 'POST',
        dataType: 'json',
        data: formData,
        success: function (response) {
            window.location.href = response.redirect;
        },
        error: function (response) {
            Swal.fire({
                position: "top-end",
                icon: "error",
                title: '<p style="font-size:16px;">' + response.responseJSON.message + '</p>',
                showConfirmButton: false,
                timer: 5000
            });
        }
    });

}

const changeLanguage = (e) => {
    e.preventDefault();

    const language = $(e.target).data('lang');

    $.ajax({
        url: '/api/switch-language/' + language,
        method: 'GET',
        success: function (response) {
            console.log(response)
            window.location.reload();
        },
        error: function (response) {
            console.log(response)
        }
    });

}


export { formSubmit, changeLanguage };
